<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="part-num"><a id="page_xx"></a><a id="page_1"></a>PART ONE</p>
<p class="part-image"><img alt="images" height="25" src="images/44_1.jpg" width="63"/></p>
<p class="part-title"><strong>VOCAL/CHORAL ISSUES</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?34bb0527